import { px2rem } from '@moim/common';
import styled, { css } from 'styled-components';

var Spacer = styled.div.withConfig({
  displayName: "Spacer",
  componentId: "sc-q14ppu-0"
})(["", " ", ""], function (props) {
  return props.width && css(["width:", ";"], props.width.unit === "px" ? px2rem(props.width.value) : "".concat(props.width.value).concat(props.width.unit));
}, function (props) {
  return props.height && css(["padding-top:", ";"], props.height.unit === "px" ? px2rem(props.height.value) : "".concat(props.height.value).concat(props.height.unit));
});

export { Spacer as default };
